exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ba-common-wizard-progress-indicator .ba-common-progressIndicator{margin-bottom:8px}.ba-common-wizard-progress-indicator>[data-tid=step-container]{display:flex;flex-wrap:nowrap}", ""]);

// exports
exports.locals = {
	"wizardProgressIndicatorClassName": "\"ba-common-wizard-progress-indicator\""
};